import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMTableHeader from "src/components/UI/atoms/ATMTableHeader/ATMTableHeader";
import {
  setRowsPerPage,
  setPage,
  setSearchValue,
  setOrderByValue
} from "src/redux/slices/AffidavitCertificateUpdateSlice";
import AuthHOC from "src/userAccess/AuthHOC";
import { AccessAction } from "src/utils/Enums/AccessAction";
import FilterAffidavitCertificateCardWrapper from "./filter/FilterAffidavitCertificateCardWrapper";
import { CircularProgress } from "@mui/material";

type Props = {
  columns: columnTypes[];
  rows: any[];
  onExportXlsx: () => void;
  isExporting: boolean;
};

const  AffidavitCertificate = ({
  columns,
  rows,
  onExportXlsx,
  isExporting,
}: Props) => {

  const dispatch = useDispatch<AppDispatch>();
  const AffidavitCertificateDoneApplicationState: any = useSelector((state: RootState) => state.AffidavitCertificateDoneApplication);
  
  const { page, rowsPerPage, isTableLoading, searchValue, totalItems, orderByValue } =
  AffidavitCertificateDoneApplicationState;

  return (

      <div className="border flex flex-col overflow-auto rounded bg-white ">
        {/*Table Header */}
        <ATMTableHeader
          page={page}
          rowCount={totalItems}
          rowsPerPage={rowsPerPage}
          rows={rows}
          onRowsPerPageChange={(newValue) => dispatch(setRowsPerPage(newValue))}
          searchValue={searchValue}
          onSearchChange={(newValue) => dispatch(setSearchValue(newValue))}
          orderValue={orderByValue}
          onOrderByChange={(newValue)=>dispatch(setOrderByValue(newValue))}
          isShowOrder={true}
          renderFilter={(close) => <FilterAffidavitCertificateCardWrapper close={close} />}
          isFilter
        />

        {/* Export XLSX Button */}
        <div className="flex items-center justify-end px-4 py-2 border-b">
          <button
            onClick={onExportXlsx}
            disabled={isExporting || !rows.length}
            className={`px-4 py-2 rounded text-white text-sm font-medium flex items-center gap-2 ${
              isExporting || !rows.length
                ? "bg-green-400 cursor-not-allowed"
                : "bg-green-600 hover:bg-green-700"
            }`}
          >
            {isExporting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            )}
            {isExporting ? "Exporting..." : "Export XLSX"}
          </button>
        </div>

        {/* Table */}
        <div className="border flex flex-col grow overflow-auto rounded bg-white">
          <ATMTable
            columns={columns}
            isLoading={isTableLoading}
            disableRowClick={
              !AuthHOC({
                type: "ACTION",
                moduleName: "EMPLOYER_CERTIFICATE",
                action: AccessAction.VIEW,
                resultType: "BOOLEAN",
              })
            }  rows={rows}
            rowExtraClasses={(row) => "min-h-[40px]"}
          //   onRowClick={(row: AffidavitCertificateUpdateListResponse) => navigate(`/pan/${row._id}`)
          // }
          />
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-end border-t border-slate-300">
          <ATMPagination
            page={page}
            rowCount={totalItems}
            rows={rows}
            rowsPerPage={rowsPerPage}
            onPageChange={(newPage) => dispatch(setPage(newPage))}
          />
        </div>
      </div>
  );
};

export default  AffidavitCertificate;
